export const BrowserClassesModule = angular
    .module('app.directives.browserClasses', [])
    .directive('browserClasses', ($window) => {
        'ngInject';

        return {
            restrict: 'A',
            link() {
                const ua = $window.navigator.userAgent;
                const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
                const webkit = !!ua.match(/WebKit/i);
                const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
                const safari = ua.match(/Safari/i) && !ua.match(/Chrome/i);

                if (iOSSafari && !angular.element('body').hasClass('safari-mobile')) {
                    angular.element('body').addClass('safari-mobile');
                }

                if (safari && !angular.element('body').hasClass('safari')) {
                    angular.element('body').addClass('safari');
                }
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/browserClasses.directive.js